import React, { useState } from 'react';
import { Autocomplete, GoogleMap, Marker, useJsApiLoader } from '@react-google-maps/api';
import { toast } from 'react-toastify';
import { ZONA_ENVIO_GRATIS } from 'constants/envios';

const containerStyle = {
	width: '100%',
	height: '500px',
};

const modalContainerStyle = {
	width: '100%',
	height: 'clamp(240px, 42vh, 420px)',
};

const center = {
	lat: -34.8746242,
	lng: -56.1013341,
};

const AREA_ENVIO_BOUNDS = {
	north: -34.8,
	south: -34.95,
	east: -55.95,
	west: -56.25,
};
const MENSAJE_FUERA_ZONA = 'No hacemos envíos a esa zona. Podés retirar tu pedido en nuestros pick-ups.';
const TOAST_FUERA_ZONA_OPTIONS = {
	autoClose: 5000,
};

const geoJsonData = {
	type: 'FeatureCollection',
	name: 'Envios',
	crs: { type: 'name', properties: { name: 'urn:ogc:def:crs:OGC:1.3:CRS84' } },
	features: [
		{
			type: 'Feature',
			properties: { Name: ZONA_ENVIO_GRATIS, description: 'sino $180' },
			geometry: {
				type: 'Polygon',
				coordinates: [
					[
						[-56.2010018, -34.8737515],
						[-56.209087, -34.8753429],
						[-56.1946847, -34.89738],
						[-56.2152841, -34.9062847],
						[-56.2139437, -34.9093516],
						[-56.2120023, -34.9119962],
						[-56.2008237, -34.9111261],
						[-56.1863618, -34.9167046],
						[-56.1728871, -34.9151908],
						[-56.1698817, -34.9238107],
						[-56.1613822, -34.9290524],
						[-56.1240208, -34.9039797],
						[-56.1240975, -34.901331],
						[-56.1224148, -34.8997734],
						[-56.1622151, -34.8676463],
						[-56.182668, -34.871118],
						[-56.1858439, -34.8718573],
						[-56.1900669, -34.8722304],
						[-56.1923145, -34.8723307],
						[-56.1947867, -34.8725274],
						[-56.1989755, -34.8734284],
						[-56.2010018, -34.8737515],
					],
				],
			},
		},
		{
			type: 'Feature',
			properties: { Name: 'Envío $200', description: null },
			geometry: {
				type: 'Polygon',
				coordinates: [
					[
						[-56.1622151, -34.8676463],
						[-56.1224148, -34.8997734],
						[-56.1009584, -34.8974976],
						[-56.0913454, -34.8951041],
						[-56.1073099, -34.8710243],
						[-56.1268793, -34.8571506],
						[-56.1449895, -34.8598269],
						[-56.1622151, -34.8676463],
					],
				],
			},
		},
		{
			type: 'Feature',
			properties: { Name: 'LA COCINA DE EMILIA', description: null },
			geometry: { type: 'Point', coordinates: [-56.158534, -34.912695] },
		},
		{
			type: 'Feature',
			properties: { Name: 'Envío $250', description: null },
			geometry: {
				type: 'Polygon',
				coordinates: [
					[
						[-56.1268793, -34.8571506],
						[-56.1073099, -34.8710243],
						[-56.0913454, -34.8951041],
						[-56.065881, -34.8996722],
						[-56.0555813, -34.8917876],
						[-56.0433279, -34.8856452],
						[-56.0356141, -34.8820631],
						[-56.0298965, -34.8785863],
						[-56.0600445, -34.866721],
						[-56.1262486, -34.8447875],
						[-56.1535283, -34.8398146],
						[-56.1749724, -34.8416005],
						[-56.2142693, -34.8577586],
						[-56.2235317, -34.8726212],
						[-56.2157607, -34.8732693],
						[-56.212154, -34.8742359],
						[-56.2102588, -34.8753604],
						[-56.1622151, -34.8676463],
						[-56.1449895, -34.8598269],
						[-56.1268793, -34.8571506],
					],
				],
			},
		},
		{
			type: 'Feature',
			properties: { Name: 'Envío $290', description: null },
			geometry: {
				type: 'Polygon',
				coordinates: [
					[
						[-56.0647557, -34.845327],
						[-56.0790894, -34.8604704],
						[-56.0600445, -34.866721],
						[-56.0539807, -34.8690731],
						[-56.0298965, -34.8785863],
						[-55.997992, -34.8613606],
						[-55.9812424, -34.8527229],
						[-55.9924667, -34.8426324],
						[-56.004258, -34.8280416],
						[-56.0146759, -34.8427568],
						[-56.0299106, -34.8476529],
						[-56.0647557, -34.845327],
					],
				],
			},
		},
	],
};

const isPointInPolygon = (point, polygon) => {
	const { lat, lng } = point;
	let inside = false;

	for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
		const [lngI, latI] = polygon[i];
		const [lngJ, latJ] = polygon[j];
		const latIAlNorte = latI > lat;
		const latJAlNorte = latJ > lat;
		const cruzaSegmento = latIAlNorte !== latJAlNorte;
		const intersectaEnLng = lng < ((lngJ - lngI) * (lat - latI)) / (latJ - latI) + lngI;
		const intersects = cruzaSegmento && intersectaEnLng;

		if (intersects) {
			inside = !inside;
		}
	}

	return inside;
};

const estaEnZonaDeEnvio = (point) =>
	geoJsonData.features
		.filter((feature) => feature.geometry?.type === 'Polygon')
		.some((feature) => isPointInPolygon(point, feature.geometry.coordinates[0]));

const limpiarDepartamento = (departamento) => departamento?.replace(/^Departamento de\s+/i, '').trim();

const obtenerComponenteDireccion = (components = [], type) =>
	components.find((component) => component.types.includes(type))?.long_name || '';

const construirDireccion = (place) => {
	const components = place.address_components || [];
	const route = obtenerComponenteDireccion(components, 'route');
	const streetNumber = obtenerComponenteDireccion(components, 'street_number');
	const ciudad =
		obtenerComponenteDireccion(components, 'locality') ||
		obtenerComponenteDireccion(components, 'sublocality') ||
		obtenerComponenteDireccion(components, 'administrative_area_level_2');
	const departamento = limpiarDepartamento(obtenerComponenteDireccion(components, 'administrative_area_level_1'));
	const calle = [route, streetNumber].filter(Boolean).join(' ').trim();
	const primeraParte = place.formatted_address?.split(',')[0]?.trim() || '';
	const esMontevideo = [ciudad, departamento].some((valor) => valor?.toLowerCase() === 'montevideo');

	if (esMontevideo) {
		return calle || primeraParte;
	}

	return [calle || primeraParte, ciudad, departamento].filter(Boolean).join(', ');
};

const MapComponent = ({ onDireccionSeleccionada, setOpcional, enviosPage, isInModal = false }) => {
	const { isLoaded } = useJsApiLoader({
		googleMapsApiKey: 'AIzaSyCg9icJTexR19NdsiyNFe8akW8Yzwoneto',
		libraries: ['places'],
	});

	const [map, setMap] = useState(null);
	const [autocomplete, setAutocomplete] = useState(null);
	const [markerPosition, setMarkerPosition] = useState(null);
	const autocompleteOptions = {
		componentRestrictions: { country: 'uy' },
		bounds: AREA_ENVIO_BOUNDS,
		strictBounds: true,
		fields: ['formatted_address', 'geometry', 'address_components'],
		types: ['address'],
	};

	const onLoad = (mapInstance) => {
		setMap(mapInstance);

		// Cargar GeoJSON al mapa
		mapInstance.data.addGeoJson(geoJsonData);

		// Aplicar estilos a los polígonos
		mapInstance.data.setStyle((feature) => {
			const name = feature.getProperty('Name'); // Obtener el nombre de la zona
			let fillColor;

			switch (name) {
				case ZONA_ENVIO_GRATIS:
					fillColor = '#FF5733'; // Color para Zona 1
					break;
				case 'Envío $200':
					fillColor = '#33FF57'; // Color para Zona 2
					break;
				case 'Envío $250':
					fillColor = '#2196F3'; // Color para Zona 2
					break;
				default:
					fillColor = 'orange'; // Color por defecto
			}

			return {
				fillColor: fillColor,
				strokeColor: '#1976D2',
				strokeWeight: 2,
				fillOpacity: 0.5,
			};
		});

		// Manejar eventos en los polígonos
		mapInstance.data.addListener('click', (event) => {
			const name = event.feature.getProperty('Name');
			const description = event.feature.getProperty('description');
			toast.info(`Zona: ${name}\n${description !== null ? description : ''}`);
		});
	};

	const onLoadAutocomplete = (autoC) => {
		setAutocomplete(autoC);
	};

	const onPlaceChanged = () => {
		try {
			if (autocomplete !== null) {
				const place = autocomplete.getPlace();
				if (!place?.geometry?.location) {
					toast.info('Debe seleccionar una dirección válida dentro del área de envío.');
					return;
				}
				const location = place.geometry.location;

				const nuevaDireccion = construirDireccion(place);
				const coordenadas = {
					lat: location.lat(),
					lng: location.lng(),
				};
				const estaEnZonaEnvio = estaEnZonaDeEnvio(coordenadas);

				// Pasa la dirección y las coordenadas al callback
				onDireccionSeleccionada({ direccion: nuevaDireccion, coordenadas, estaEnZonaEnvio });

				if (!estaEnZonaEnvio) {
					toast.error(MENSAJE_FUERA_ZONA, TOAST_FUERA_ZONA_OPTIONS);
				}

				console.log('Dirección:', nuevaDireccion);
				console.log('Coordenadas:', coordenadas);

				// Mueve el mapa al lugar seleccionado
				map.panTo(coordenadas);
				map.setZoom(16);

				// Coloca un marcador en el lugar seleccionado
				setMarkerPosition(coordenadas);
			} else {
				console.log('Autocomplete is not loaded yet!');
			}
		} catch (error) {
			toast.info('Debe seleccionar una opción de las sugeridas.');
		}
	};

	return isLoaded ?
			<>
				<Autocomplete onLoad={onLoadAutocomplete} onPlaceChanged={onPlaceChanged} options={autocompleteOptions}>
					<input
						type="text"
						placeholder="Ingresar calle y numero de puerta"
						style={{
							width: '100%',
							padding: '10px',
							marginBottom: '10px',
							border: '1px solid #ccc',
							borderRadius: '4px',
						}}
						onSubmit={false}
					/>
				</Autocomplete>
				{!enviosPage && (
					<input
						type="text"
						placeholder="(Opcional) Aclaraciones para el cadete: timbre, esquina, sin número..."
						onChange={(e) => setOpcional?.(e.target.value)}
						style={{
							width: '100%',
							padding: '10px',
							marginBottom: '10px',
							border: '1px solid #ccc',
							borderRadius: '4px',
						}}
					/>
				)}
				<GoogleMap
					mapContainerStyle={isInModal ? modalContainerStyle : containerStyle}
					center={center}
					zoom={12}
					onLoad={onLoad}
					options={isInModal ? { gestureHandling: 'cooperative' } : undefined}
				>
					{markerPosition && <Marker position={markerPosition} />}
				</GoogleMap>
			</>
		:	<p>Cargando...</p>;
};

export default MapComponent;
